export const AuthData = {
  isFieldTrial: false,
  success: false,
  useV3: false,
};

/**
 * Fill AuthData with data from cookies.
 */
export const setAuthData = ({
  firstName,
  lastName,
  studentId,
  organization,
  group,
  grade,
  sessionId,
  isTestUser,
  isSpecialContentLicense,
  isStaffLogin,
} = {}) => {
  AuthData.firstName = firstName || '';
  AuthData.lastName = lastName || '';
  AuthData.studentId = studentId || '';
  AuthData.organization = organization || '';
  AuthData.group = group || '';
  AuthData.grade = grade || '';
  AuthData.sessionId = AuthData.sessionId || sessionId || '';
  AuthData.isTestUser = isTestUser || false;
  AuthData.isSpecialContentLicense = isSpecialContentLicense || false;
  AuthData.isStaffLogin = isStaffLogin || false;
};
